export const RaShowStylesStyles = {
    styleOverrides: {
        root: {
            '& .RaShow-noActions': {
                margin: 0,
            },
        },
    },
};
